
import React from 'react';
import gs1PressReleasePdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/OECD-GS1 press release on GlobalRecalls portal.pdf';
import officialLaunchSpeechPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/Speech for the official launch of the OECD globalrecalls portal.pdf';

const OfficialLaunch = () => (
  <div className="container main">
    <h2>ポータルの開始</h2>
    <hr/>
    <div className="row">
      <div className="col-sm-6">
        <p>
          GlobalRecallsポータルは、2012年10月19日にベルギーのブリュッセルで開催された<a href="http://ec.europa.eu/consumers/events/ipsw_2012/index_en.htm" target="_blank">国際製品安全週間</a>で立ち上げられました。イベントの<a
          href="http://ec.europa.eu/consumers/archive/events/ipsw_2012/programme_en.htm"
          target="_blank">スケジュール</a>
          と<a href="http://ec.europa.eu/consumers/archive/events/ipsw_2012/gallery_en.htm"
                 target="_blank">写真 </a>はこちらをご覧ください。
        </p>
      </div>
      <div className="col-sm-6">
        <h4>プレゼンテーションと講演</h4>
        <ul>
          <li><a href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/presentation_p_testori_en.pdf"
                 target="_blank">パオラ・テストーリ＝コッジ氏</a>, <em>欧州委員会健康消費者保護総局局長</em>
          </li>
          <li><a
            href="http://www.cpsc.gov/en/About-CPSC/Chairman/Speeches/Press-event-launching-GlobalRecalls-Web-Portal/"
            target="_blank">アイネズ・テネンバウム氏</a>, <em>米国消費者製品安全委員会委員長</em>
          </li>
          <li><a
            href={officialLaunchSpeechPdf}
            target="_blank">玉木林太郎氏</a>, <em>経済協力開発機構（OECD）事務次長</em>
          </li>
          <li><a
            href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/tom_phillips_111_oecd_recalls_portal_presentation_en.pdf"
            target="_blank">トム・フィリップス氏</a>, <em>OECD消費者製品安全作業部会代表</em>
          </li>
          <li><a href="http://ec.europa.eu/consumers/events/ipsw_2012/docs/global_portal_on_product_recalls_qa_en.pdf"
                 target="_blank">このポータルに関するQ&A</a>
          </li>
        </ul>
      </div>
    </div>
    <hr/>
    <div className="row">
      <div className="col-sm-6">
        <h4>メディア報道</h4>
        <ul>
          <li><a
            href="http://www.heraldsun.com.au/news/national/five-million-items-subject-to-recalls-in-australia-since-july-last-year-accc-data-shows/story-fndo48ca-1226498875141"
            target="_blank">Five million items subject to recalls in Australia since July last year, ACCC data
            shows</a>, <em>Herald Sun</em>, Australia
          </li>
          <li><a
            href="http://www.7sur7.be/7s7/fr/1537/Consommation/article/detail/1520261/2012/10/19/Securite-des-produits-l-OCDE-propose-desormais-un-portail-internet.dhtml"
            target="_blank">Sécurité des produits: l'OCDE propose désormais un portail internet</a>, <em>7 sur 7</em>,
            Belgium
          </li>
          <li><a
            href="http://slobodnadalmacija.hr/Svijet/tabid/67/articleType/ArticleView/articleId/191794/Default.aspx"
            target="_blank">Zaživio međunarodni portal s listom zabranjenih proizvoda</a>, <em>Slobodna
            Dalimacija</em>, Croatia
          </li>
          <li><a
            href="http://www.enviweb.cz/clanek/zdrav/93471/novy-mezinarodni-portal-s-informacemi-o-nebezpecnych-vyrobcich">Nový
            mezinárodní portál s informacemi o nebezpečných výrobcích</a>, <em>EnviWeb</em>, Czech Republic
          </li>
          <li><a href="http://www.eu-infothek.com/article/verbraucherschutz-produktrueckrufe-weltweit-auf-einen-klick"
                 target="_blank">Verbraucherschutz – Produktrückrufe weltweit auf einen Klick</a>, <em>Eu
            InfoThek</em>, Europe
          </li>
          <li><a href="http://www.baltic-course.com/eng/good_for_business/?doc=64717">Consumer Safety: priority for EU
            and other global partners</a>, <em>Baltic Course</em>, Europe
          </li>
          <li><a
            href="http://www.francematin.info/L-OCDE-lance-un-portail-en-ligne-pour-renforcer-la-securite-des-produits_a25628.html"
            target="_blank"> L’OCDE lance un portail en ligne pour renforcer la sécurité des produits</a>, <em>France
            Matin</em>, France
          </li>
          <li><a href="http://www.caradisiac.com/Globalrecalls-le-site-des-rappels-du-monde-entier-81977.htm"
                 target="_blank">GlobalRecalls : le site des rappels du monde entier</a>, <em>Caradisiac</em>, France
          </li>
          <li><a
            href="http://www.info.expoprotection.com/site/FR/LOCDE_lance_un_portail_en_ligne_sur_les_produits_retires_du_marche,C1294,I1312,Zoom-bebca6d9380294d323b99d631e25ba44,FromPage-R.htm?KM_Session=fc8085f94db394b2f9d037eea50098c5"
            target="_blank">L’OCDE lance un portail sur les produits de consommation retirés du marché parce que
            dangereux</a>, <em>L'Info Expoprotection</em>, France
          </li>
          <li><a href="http://www.service-public.fr/actualites/002553.html" target="_blank">L’OCDE informe sur les
            produits retirés du marché à travers le monde</a>, <em>Service Public</em>, France
          </li>
          <li><a
            href="http://www.helpconsumatori.it/acquisti/sicurezza-prodotti-inaugurato-a-bruxelles-il-global-recalls-portal/54590"
            target="_blank">Sicurezza prodotti, inaugurato a Bruxelles il Global Recalls Portal</a>, <em>Help
            Consumatori</em>, Italy
          </li>
          <li><a href="http://www.barlavento.pt/index.php/noticia?id=54280" target="_blank">Portal informa sobre
            segurança dos produtos</a>, <em>Barlavento</em>, Mexico
          </li>
          <li><a href="http://www.ekonomia24.pl/artykul/706165,944026-Zanim-zrobisz-zakupy.html" target="_blank">Skarb
            dla konsumenta</a>, <em>Ekonomia24</em>, Poland
          </li>
          <li><a href="http://www.jn.pt/PaginaInicial/Sociedade/Interior.aspx?content_id=2837645" target="_blank">Portal
            reúne produtos retirados de circulação em todo o Mundo</a>, <em>Jornal de Notícias</em>, Portugal
          </li>
          <li><a href="http://www.svet-komunikacie.sk/index.php?ID=11729" target="_blank">On-line:Stiahnuté výrobky z
            trhu</a>, <em>Svet Komunikácie</em>, Slovak Republic
          </li>
          <li><a href="http://www.dnevnik.si/zdravje/1042558583" target="_blank">Predstavili mednarodni spletni portal
            za obveščanje o odpoklicih nevarnih izdelkov</a>, <em>Dnevnik</em>, Slovenia
          </li>
          <li><a
            href="http://latinalista.com/2012/10/new-online-portal-lets-people-around-the-world-see-which-products-have-been-recalled/"
            target="_blank">New online portal lets people around the world see which products have been recalled</a>,
            <em>Latina Lista</em>, United States
          </li>
          <li><a href="http://www.rttnews.com/1986752/check-product-recalls-worldwide-in-a-few-clicks.aspx?type=gn"
                 target="_blank">Check Product Recalls Worldwide In A Few Clicks!</a>, <em>RTT News</em>, United
            States
          </li>
        </ul>
      </div>
      <div className="col-sm-6">
        <h4>プレスリリース</h4>
        <ul>
          <li><a
            href={gs1PressReleasePdf}
            target="_blank">OECD-GS1プレスリリース </a>（2013年4月30日）
          </li>
          <li>OECDプレスリリース：<a
            href="http://www.oecd.org/newsroom/oecdlaunchesonlineportaltoboostproductsafety.htm"
            target="_blank">英語</a>、
            <a href="http://www.oecd.org/fr/presse/locdelanceunportailenlignepourrenforcerlasecuritedesproduits.htm" target="_blank">フランス語</a>&nbsp;（2012年10月19日）
          </li>
          <li><a href="http://www.accc.gov.au/content/index.phtml/itemId/1085749/fromItemId/2332" target="_blank">オーストラリア競争・消費者委員会：国際製品安全週間、オンラインショッピングのリスクを強調</a>&nbsp;（2012年10月19日）
          </li>
          <li>欧州委員会の<a href="http://europa.eu/rapid/press-release_IP-12-1127_en.htm?locale=en"
                                       target="_blank">プレスリリース </a>と <a href="http://europa.eu/rapid/press-release_MEMO-12-791_en.htm?locale=en" target="_blank">Q&A資料</a>&nbsp;（2012年10月19日）
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default OfficialLaunch;



// WEBPACK FOOTER //
// ./src/views/static/ja/official-launch.js